module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "calibre4"
  }, [_vm._v("Personen und ihre Masken")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Epidicus")]), _vm._v(", Sklave")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Thesprio")]), _vm._v(", Sklave")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Stratippocles")]), _vm._v(", junger Mann")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Chaeribulus")]), _vm._v(", junger Mann")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Periphane")]), _vm._v("s, alter Mann")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Apoecides")]), _vm._v(", alter Mann")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ein Sklave")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Eine Harfenspielerin")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ein Söldner")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Philippa")]), _vm._v(", Frau aus Theben")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Acropolistis")]), _vm._v(", Harfenspielerin")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ein Geldverleiher")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Telestis")]), _vm._v(", Jungfrau")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', [_vm._v("Ort der Handlung: Athen")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("Die Szene zeigt die Vorderseite zweier Häuser, das Haus des Periphanes und das des Chaeribulus")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61e0429a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/chapter1.vue
// module id = 60
// module chunks = 0